import cloneDeep from 'lodash/cloneDeep';
import itemsFetcher from './itemsFetcher';

// const items = {};

class ItemFetchFactory {
  constructor(fetchType) {
    // console.count('INIT FACTORY');
    this.fetchType = fetchType;
    this.fetchItems = itemsFetcher(fetchType).fetchForItems;
    this.items = {};
  }

  addItem = (itemId, itemData) => {
    let callBackFuncs = [];
    if (this.items[itemId].loading) {
      callBackFuncs = this.items[itemId].fetchCallbacks;
    }
    this.items[itemId] = itemData;
    callBackFuncs.forEach(callback => callback(itemData));
    // this.items[itemId] = itemData;
  };

  fetchItemForId(itemId, callback, returnString, fieldName) {
    if (this.items[itemId] && !this.items[itemId].loading) {
      // callback(this.items[itemId]);
      if (fieldName) {
        // callback(this.items[itemId][fieldName]);
        return this.items[itemId][fieldName];
      }
      // callback(this.items[itemId]);
      return this.items[itemId];
    }
    if (this.items[itemId] && this.items[itemId].loading) {
      this.items[itemId].fetchCallbacks.push(callback);
      if (returnString) {
        return 'loading';
      }
      return this.items[itemId];
    }

    this.items[itemId] = {
      loading: true,
      fetchCallbacks: [callback]
    };
    this.fetchItems(itemId, this.fetchingDone);

    if (returnString) {
      return 'loading';
    }
    return this.items[itemId];
  }

  setNotFound = (itemsData, itemIds) => {
    const itemPids = cloneDeep(itemIds);
    itemsData.forEach((item) => {
      const index = itemIds.indexOf(item.pid);
      if (index > -1) {
        itemPids.splice(index, 1);
      }
    });
    if (itemPids.length > 0) {
      itemPids.forEach((pid) => {
        this.addItem(pid, {
          notFound: true
        });
      });
    }
  };

  fetchingDone = (response, itemIds) => {
    if (response && response.data && response.data[this.fetchType]) {
      let itemsData = response.data[this.fetchType];
      itemsData = itemsData.filter(item => !!item);
      const filtereditemIds = itemIds.filter(item => !!item);
      itemsData.forEach((item) => {
        item && this.addItem(item.pid, item);
      });
      if (itemsData.length < filtereditemIds.length) {
        this.setNotFound(itemsData, filtereditemIds);
      }
    }
  };
}

export default ItemFetchFactory;
